import AccommodationService from './accommodationService/AccommodationService'
import RateInsightsService from './accommodationService/RateInsightsService'
import AdminService from './AdminService'
import DashboardService from './DashboardService'
import OAuth2JLoService from './OAuth2JLoService'
import OrganisationManagementService from './OrganisationManagementService'
import ChatbotService from './premiumService/ChatbotService'
import HotelOffersService from './premiumService/HotelOffersService'
import PremiumService from './premiumService/PremiumService'
import RateConnectService from './premiumService/RateConnectService'
import SmartBoostService from './premiumService/SmartBoostService'
import PropertyDetailsService from './PropertyDetailsService'


const apis = {
  oauth2: OAuth2JLoService,
  admin: AdminService,
  organisation: OrganisationManagementService,
  propertyDetails: PropertyDetailsService,
  dashboard: DashboardService,
  rateInsights: RateInsightsService,
  accommodation: AccommodationService,
  premium: PremiumService,
  chatbot: ChatbotService,
  hotelOffers: HotelOffersService,
  rateConnect: RateConnectService,
  smartBoost: SmartBoostService,
} as const

export default apis